module.exports = "<div class=\"lg-col-5 md-col-7 sm-col-8 px2 mx-auto\">\n<h2 class=\"color-green center\">Online bestellen</h2>\n    <!--<div class=\"mb2 mt4 mb4 center\">\n      <a v-on='click: toggle_shop()' class=\"button button-blue button-big\">\n        {{t('titel')}}\n        <i class=\"ml1 ion ion-bag\"></i>\n      </a>\n    </div>  v-if='shop_open' -->\n    <sell-form v-on:submited=\"submited = true\" :home_url=\"home_url\" :swisslink=\"swisslink\"></sell-form>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./lib/runes-set-order/index.html
// module id = 50
// module chunks = 0